import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { userService } from 'services';

export const fetchUserProfile = createAsyncThunk(
    'auth/fetchUserProfile',
    async (_, { rejectWithValue }) => {
        try {
            const response = await userService.getUserProfile();
            // Assuming response.data.data is the user object based on UserContext.js
            return response.data.data;
        } catch (error) {
            console.error(error);
            return rejectWithValue(error.response?.data || 'Failed to fetch profile');
        }
    }
);

const initialState = {
    user: {},
    token: localStorage.getItem('token') || null, // Assuming token might be persisted
    loading: false,
    error: null,
};

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setToken: (state, action) => {
            state.token = action.payload;
            if (action.payload) {
                localStorage.setItem('token', action.payload);
            } else {
                localStorage.removeItem('token');
            }
        },
        setUser: (state, action) => {
            state.user = action.payload;
        },
        logout: (state) => {
            state.user = {};
            state.token = null;
            state.error = null;
            localStorage.removeItem('token');
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchUserProfile.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchUserProfile.fulfilled, (state, action) => {
                state.loading = false;
                state.user = action.payload;
            })
            .addCase(fetchUserProfile.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export const { setToken, logout, setUser } = authSlice.actions;
export default authSlice.reducer;
